<template>
    <tr class="tableTr">
        <td class="dense" :class="{'tdGreen': checkClasses['filter_unit']}">{{ item.unit }}</td>
        <td class="dense" :class="{'tdGreen': checkClasses['filter_id']}">{{ item.id }}</td>
        <td :class="{'tdGreen': checkClasses['filter_wo_type']}">{{ item.type }}</td>
        <td class="dense" :class="{'tdGreen': checkClasses['filter_request_date'] || filterClassesActive('filter_request_date')}">{{ item['request_date'] }}</td>
        <td class="dense" :class="{'tdGreen': checkClasses['filter_arrival_date'] || filterClassesActive('filter_arrival_date')}">{{ item['arrival_date'] }}</td>
        <td class="dense" :class="{'tdGreen': checkClasses['filter_check_out'] || filterClassesActive('filter_check_out')}">{{ item['check_out'] }}</td>
    </tr>
</template>

<script>

export default {
	name: "TableTr",
	props: {
		item: Object,
		permissions: Object,
		checkClasses: Object,
		filterClassesActive: Function,
		idx: Number
	}
};
</script>

<style lang="scss" scoped>
@import "statisticsInfoTableTR";
</style>

<style lang="scss">
@import "statisticsInfoTableTRAll";
</style>
